import { FC, PropsWithChildren } from 'react';

import { Stack, Typography } from '@mui/material';
import { NeutralColors } from 'portfolio3/styles';
import { SxStyles } from 'types';
import { mergeSx } from 'utils';

const rootStyles: SxStyles = (theme) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',

  width: '100%',
  paddingBlock: '16px 24px',
  paddingInline: '20px',

  border: '1px solid',
  borderRadius: '12px',
  borderColor: NeutralColors.light_neutrals_300,
  boxShadow: '0px 1px 2px rgba(41, 41, 64, 0.07)',
  backgroundColor: NeutralColors.light_neutrals_0,

  [theme.breakpoints.down('commonSm')]: {
    gap: '12px',
    padding: '12px',
  },
});

interface IDiagramCardProps {
  title: string;
  sx?: SxStyles;
}

const DiagramCard: FC<IDiagramCardProps & PropsWithChildren> = ({ title, sx, children }) => {
  return (
    <Stack className="diagram-card" sx={mergeSx(rootStyles, sx)}>
      <Typography variant="Paragraph LG/Semi Bold">{title}</Typography>
      {children}
    </Stack>
  );
};

export default DiagramCard;
